<template>
  <div class="honor-item">
    <div class="honor-item__img-wrap">
      <img
        :class="vertical ? 'vertical' : 'horizontal'"
        :src="img"
        :alt="name"
      >
    </div>
    <div class="honor-item__name">{{name}}</div>
  </div>
</template>

<script>
export default {
  name: 'HonorItem',
  props: {
    vertical: {
      type: Boolean,
      default: false
    },
    img: String,
    name: String
  }
}
</script>

<style lang="less" scoped>
.honor-item {
  width: 384px;
  &__img-wrap {
    position: relative;
    height: 234px;
    .img-position(@left, @bottom) {
      position: absolute;
      left: @left;
      bottom: @bottom;
      transform: translate(-50%, 50%);
    }
    position: relative;
    .vertical {
      .img-position(50%, 20px);
      width: 175px;
      height: 255px;
      transform: translate(-50%, 0);
    }
    .horizontal {
      .img-position(50%, 50%);
      width: 273px;
      height: 194px;
    }
    background-color: #f7f9fc;
  }
  &__name {
    padding: 16px 0;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: #3a416b;
    background-color: #ebefff;
  }
}
</style>
